import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { normalizeSpecialistRoleKey } from "../helpers/activeSpecialistRoleHelper";
import { isFlowEngineEnabledForProcess, resolveFlowRoleContext } from "../helpers/flowEngineConfigHelper";
import { canSaveFlowRecord, resolveAuthUserId } from "../helpers/flowEditPageHelper";
import { readFichaReturnContext } from "../helpers/moduleFichaNavHelper";

const useCanSaveFlowEditRecord = (record, moduleProcess) => {
  const location = useLocation();
  const userRole = useSelector((state) => state.userRole);
  const auth = useSelector((state) => state.auth);
  const configuration = useSelector((state) => state.configuration);
  const flowEngine = useSelector((state) => state.flowEngine);

  const roleContext = useMemo(
    () => resolveFlowRoleContext({ userRole, authUser: auth?.user }),
    [userRole, auth]
  );
  const selectedRole = userRole?.roleLogin?.roleSpecialistSelected || null;
  const roleKey = normalizeSpecialistRoleKey(selectedRole) || roleContext.roleCode;
  const trayView = location.state?.trayView
    || readFichaReturnContext(moduleProcess).trayView
    || "";

  return canSaveFlowRecord({
    record,
    roleId: selectedRole?.id || roleContext.roleId,
    flowEngineEnabled: isFlowEngineEnabledForProcess(configuration, moduleProcess),
    flowEngine,
    roleKey,
    actorUserId: resolveAuthUserId(auth?.user),
    trayView
  });
};

export default useCanSaveFlowEditRecord;
